import { render, staticRenderFns } from "./TrialPill.vue?vue&type=template&id=0a743ef7&"
import script from "./TrialPill.vue?vue&type=script&lang=js&"
export * from "./TrialPill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports